import styled, { css } from 'styled-components';
import { getTextType, getGridSpans, px2rem, mq, getSpace } from '../../../stylesheets/tools';

const StyledInfoGraphic = styled.div`
  .infoGraphic__number {
    font-size: ${props => (props.numberLength <= 4 ? px2rem('100px') : px2rem('70px'))};
    min-height: ${px2rem('100px')};
    line-height: 1;
    margin-bottom: ${px2rem('10px')};
    color: ${props => props.theme.siteTheme.borderColor};
    white-space: nowrap;
  }

  svg {
    height: 50px;
    width: auto;
    margin-bottom: ${px2rem('20px')};
    fill: ${props => props.theme.siteTheme.borderColor};
  }

  .infoGraphic__subline {
    position: relative;
    padding-left: 45px;

    &:before {
      position: absolute;
      top: calc(50% - 1px);
      left: 0;
      content: '';
      width: 30px;
      height: 2px;
      background: #000;
    }
  }

  ${mq('m')} {
    .infoGraphic__copy {
      padding-right: ${getSpace('m')};

      p {
        margin: ${getSpace('xs')} 0;
        ${getTextType('copySmall', 'international')}
      }
    }
  }

  ${props =>
    props.alignment &&
    css`
      ${getGridSpans('width', { s: 12, m: 5, l: 3 })}
      ${getGridSpans(`margin-${props.alignment === 'right' ? 'left' : 'right'}`, {
        s: 0,
        m: [1, 'spread']
      })}

      ${mq('m')} {
        float: ${props.alignment};
        margin-top: ${!props.hasIcon ? '75px' : '0'};
      }
    `}

  ${props =>
    props.vertical &&
    css`
      margin: ${getSpace('xl')} 0;

      ${mq('m')} {
        display: flex;
      }

      .infoGraphic__headline {
        ${getGridSpans('width', { s: 12, m: [4, 'spread'], l: [3, 'spread'] })}
      }
      .infoGraphic__copy {
        ${getGridSpans('width', { s: 12, m: [6, 'spread'], l: [7, 'spread'] })}

        ${mq('m')} {
          margin-top: ${props.hasIcon ? '75px' : '5px'};
        }
      }
    `}
`;

export default StyledInfoGraphic;
